import { useMemo } from 'react'

import { VStack } from '@chakra-ui/react'
import { EDITOR_TOOLS, PanelType } from '@editor/config/constants'
import { useEditorContext } from '@editor/contexts/Editor'
import { InspectionItemType } from '@editor/interfaces/inspection'
import CollapsePanel from '@editor/pages/projects/editor/infoPanels/components/CollapsePanel'
import { toggleCollapsedPanel } from '@editor/pages/projects/editor/store/editor'
import { RootState, useAppDispatch } from '@editor/store/app'
import { useSelector } from 'react-redux'

import { Mode } from '../../utils'
import EstimationMethod from './EstimationMethod'
import PlaneSideSelection from './PlaneSideSelection'

const VolumeSetupPanel = () => {
  // Context
  const { selectedTool } = useEditorContext()

  // Store
  const dispatch = useAppDispatch()
  const inspectionItems = useSelector((state: RootState) => state.inspectionItems.items)
  const selectedElementIds = useSelector((state: RootState) => state.toolUtil.core.selectedElementIds)
  const jobRunningTool = useSelector((state: RootState) => state.editor.jobRunningTool)
  const collapsedPanel = useSelector((state: RootState) => state.editor.collapsedPanel)

  // Flags
  const isCollapsed = useMemo(() => collapsedPanel.includes(PanelType.Tool), [collapsedPanel])
  const isToolSelected = useMemo(() => selectedTool === EDITOR_TOOLS.VOLUME_POLYGON, [selectedTool])
  const selectedVolumes = useMemo(
    () =>
      inspectionItems.filter(
        (item) =>
          item.item_type === InspectionItemType.Volume &&
          selectedElementIds.find((id) => item.shape_ids.polygons.includes(id)),
      ),
    [selectedElementIds, inspectionItems],
  )
  const selectedVolume = selectedVolumes[0]
  const mode = useMemo(() => {
    if (isToolSelected) return Mode.Modelling
    if (selectedVolume && selectedTool === EDITOR_TOOLS.MOVE && jobRunningTool === '') return Mode.Reevaluation
    return Mode.None
  }, [isToolSelected, selectedTool, selectedVolume, jobRunningTool])

  // Only for when volume is selected or tool is selected
  if (mode === Mode.None) {
    return null
  }

  return (
    <CollapsePanel
      title="体積の設定"
      onChange={() => dispatch(toggleCollapsedPanel(PanelType.Tool))}
      isCollapsed={isCollapsed}
    >
      <VStack data-testid="plane-side-selection-panel" className="inner-container" gap={5}>
        {isToolSelected ? <PlaneSideSelection /> : null}
        <EstimationMethod mode={mode} />
      </VStack>
    </CollapsePanel>
  )
}

export default VolumeSetupPanel
